import {ALL} from '@milestoneslabs/milestones-core-js/src/AppResources/LuHomeTypeAppResource';

const PRICES = {
    min: [
        {
            value: 0,
            label: 'No Min'
        },
        {
            value: 10000,
            label: '$10k'
        },
        {
            value: 20000,
            label: '$20k'
        },
        {
            value: 30000,
            label: '$30k'
        },
        {
            value: 50000,
            label: '$50k'
        },
        {
            value: 75000,
            label: '$75k'
        },
        {
            value: 100000,
            label: '$100k'
        },
        {
            value: 125000,
            label: '$125k'
        },
        {
            value: 150000,
            label: '$150k'
        },
        {
            value: 175000,
            label: '$175k'
        },
        {
            value: 200000,
            label: '$200k'
        },
        {
            value: 225000,
            label: '$225k'
        },
        {
            value: 250000,
            label: '$250k'
        },
        {
            value: 275000,
            label: '$275k'
        },
        {
            value: 300000,
            label: '$300k'
        },
        {
            value: 325000,
            label: '$325k'
        },
        {
            value: 350000,
            label: '$350k'
        },
        {
            value: 375000,
            label: '$375k'
        },
        {
            value: 400000,
            label: '$400k'
        },
        {
            value: 425000,
            label: '$425k'
        },
        {
            value: 450000,
            label: '$450k'
        },
        {
            value: 475000,
            label: '$475k'
        },
        {
            value: 500000,
            label: '$500k'
        },
        {
            value: 550000,
            label: '$550k'
        },
        {
            value: 600000,
            label: '$600k'
        },
        {
            value: 650000,
            label: '$650k'
        },
        {
            value: 700000,
            label: '$700k'
        },
        {
            value: 750000,
            label: '$750k'
        },
        {
            value: 800000,
            label: '$800k'
        },
        {
            value: 850000,
            label: '$850k'
        },
        {
            value: 900000,
            label: '$900k'
        },
        {
            value: 950000,
            label: '$950k'
        },
        {
            value: 1000000,
            label: '$1m'
        },
        {
            value: 1100000,
            label: '$1.1m'
        },
        {
            value: 1200000,
            label: '$1.2m'
        },
        {
            value: 1250000,
            label: '$1.25m'
        },
        {
            value: 1400000,
            label: '$1.4m'
        },
        {
            value: 1500000,
            label: '$1.5m'
        },
        {
            value: 1600000,
            label: '$1.6m'
        },
        {
            value: 1700000,
            label: '$1.7m'
        },
        {
            value: 1750000,
            label: '$1.75m'
        },
        {
            value: 1800000,
            label: '$1.8m'
        },
        {
            value: 1900000,
            label: '$1.9m'
        },
        {
            value: 2000000,
            label: '$2m'
        },
        {
            value: 2250000,
            label: '$2.25m'
        },
        {
            value: 2500000,
            label: '$2.5m'
        },
        {
            value: 2750000,
            label: '$2.75m'
        },
        {
            value: 3000000,
            label: '$3m'
        },
        {
            value: 3250000,
            label: '$3.25m'
        },
        {
            value: 3500000,
            label: '$3.5m'
        },
        {
            value: 3750000,
            label: '$3.75m'
        },
        {
            value: 4000000,
            label: '$4m'
        },
        {
            value: 4250000,
            label: '$4.25m'
        },
        {
            value: 4500000,
            label: '$4.5m'
        },
        {
            value: 4750000,
            label: '$4.75m'
        },
        {
            value: 5000000,
            label: '$5m'
        },
        {
            value: 6000000,
            label: '$6m'
        },
        {
            value: 7000000,
            label: '$7m'
        },
        {
            value: 8000000,
            label: '$8m'
        },
        {
            value: 9000000,
            label: '$9m'
        },
        {
            value: 10000000,
            label: '$10m'
        },
        {
            value: 20000000,
            label: '$20m'
        },
    ],
    max: [
        {
            value: null,
            label: 'No Max'
        },
        {
            value: 10000,
            label: '$10k'
        },
        {
            value: 20000,
            label: '$20k'
        },
        {
            value: 30000,
            label: '$30k'
        },
        {
            value: 50000,
            label: '$50k'
        },
        {
            value: 75000,
            label: '$75k'
        },
        {
            value: 100000,
            label: '$100k'
        },
        {
            value: 125000,
            label: '$125k'
        },
        {
            value: 150000,
            label: '$150k'
        },
        {
            value: 175000,
            label: '$175k'
        },
        {
            value: 200000,
            label: '$200k'
        },
        {
            value: 225000,
            label: '$225k'
        },
        {
            value: 250000,
            label: '$250k'
        },
        {
            value: 275000,
            label: '$275k'
        },
        {
            value: 300000,
            label: '$300k'
        },
        {
            value: 325000,
            label: '$325k'
        },
        {
            value: 350000,
            label: '$350k'
        },
        {
            value: 375000,
            label: '$375k'
        },
        {
            value: 400000,
            label: '$400k'
        },
        {
            value: 425000,
            label: '$425k'
        },
        {
            value: 450000,
            label: '$450k'
        },
        {
            value: 475000,
            label: '$475k'
        },
        {
            value: 500000,
            label: '$500k'
        },
        {
            value: 550000,
            label: '$550k'
        },
        {
            value: 600000,
            label: '$600k'
        },
        {
            value: 650000,
            label: '$650k'
        },
        {
            value: 700000,
            label: '$700k'
        },
        {
            value: 750000,
            label: '$750k'
        },
        {
            value: 800000,
            label: '$800k'
        },
        {
            value: 850000,
            label: '$850k'
        },
        {
            value: 900000,
            label: '$900k'
        },
        {
            value: 950000,
            label: '$950k'
        },
        {
            value: 1000000,
            label: '$1m'
        },
        {
            value: 1100000,
            label: '$1.1m'
        },
        {
            value: 1200000,
            label: '$1.2m'
        },
        {
            value: 1250000,
            label: '$1.25m'
        },
        {
            value: 1400000,
            label: '$1.4m'
        },
        {
            value: 1500000,
            label: '$1.5m'
        },
        {
            value: 1600000,
            label: '$1.6m'
        },
        {
            value: 1700000,
            label: '$1.7m'
        },
        {
            value: 1750000,
            label: '$1.75m'
        },
        {
            value: 1800000,
            label: '$1.8m'
        },
        {
            value: 1900000,
            label: '$1.9m'
        },
        {
            value: 2000000,
            label: '$2m'
        },
        {
            value: 2250000,
            label: '$2.25m'
        },
        {
            value: 2500000,
            label: '$2.5m'
        },
        {
            value: 2750000,
            label: '$2.75m'
        },
        {
            value: 3000000,
            label: '$3m'
        },
        {
            value: 3250000,
            label: '$3.25m'
        },
        {
            value: 3500000,
            label: '$3.5m'
        },
        {
            value: 3750000,
            label: '$3.75m'
        },
        {
            value: 4000000,
            label: '$4m'
        },
        {
            value: 4250000,
            label: '$4.25m'
        },
        {
            value: 4500000,
            label: '$4.5m'
        },
        {
            value: 4750000,
            label: '$4.75m'
        },
        {
            value: 5000000,
            label: '$5m'
        },
        {
            value: 6000000,
            label: '$6m'
        },
        {
            value: 7000000,
            label: '$7m'
        },
        {
            value: 8000000,
            label: '$8m'
        },
        {
            value: 9000000,
            label: '$9m'
        },
        {
            value: 10000000,
            label: '$10m'
        },
        {
            value: 20000000,
            label: '$20m'
        },
    ],
};

const BEDS = [
    {
        value: 0,
        label: 'Studio+'
    },
    {
        value: 1,
        label: '1+'
    },
    {
        value: 2,
        label: '2+'
    },
    {
        value: 3,
        label: '3+'
    },
    {
        value: 4,
        label: '4+'
    },
];

const BATHS = [
    {
        value: 0,
        label: 'Any'
    },
    {
        value: 1,
        label: '1+'
    },
    {
        value: 2,
        label: '2+'
    },
    {
        value: 3,
        label: '3+'
    },
    {
        value: 4,
        label: '4+'
    },
    {
        value: 5,
        label: '5+'
    },
];

const HOME_TYPES = [
    {
        value: ALL.SINGLE_FAMILY_HOUSE,
        label: 'Single-Family/House',
    },
    {
        value: ALL.CONDO,
        label: 'Condo',
    },
    {
        value: ALL.TOWNHOME,
        label: 'Townhome',
    },
    {
        value: ALL.MULTI_FAMILY,
        label: 'Multi-family',
    },
    {
        value: ALL.LAND,
        label: 'Land',
    },
    {
        value: ALL.MOBILE_MANUFACTURED,
        label: 'Mobile/Manufactured',
    },
    {
        value: ALL.OTHER,
        label: 'Other',
    },
];

const SALE_TYPES = [
    {
        value: {
            field: 'details.newConstruction',
            operator: '=',
            fieldValue: false,
        },
        label: 'Resale'
    },
    {
        value: {
            field: 'details.newConstruction',
            operator: '=',
            fieldValue: true,
        },
        label: 'New Construction',
    },
    {
        value: {
            field: 'details.daysOnMarket',
            operator: '<=',
            fieldValue: 7,
        },
        label: 'New Listings',
    },
    {
        value: {
            field: 'details.openHouses',
            operator: 'isNotNull',
            fieldValue: null,
        },
        label: 'Open Houses',
    },
];

const SORT_TYPES = {
    COLUMN: 'column',
    COUNT: 'count',
};

const SORT_FIELDS = [
    {
        text: 'Price: High to Low',
        value: 'price_high_to_low',
        field: 'price',
        direction: 'desc',
        type: SORT_TYPES.COLUMN,
    },
    {
        text: 'Price: Low to High',
        value: 'price_low_to_high',
        field: 'price',
        direction: 'asc',
        type: SORT_TYPES.COLUMN,
    },
    {
        text: 'Bedrooms',
        value: 'bedrooms_descending',
        field: 'bedrooms',
        direction: 'desc',
        type: SORT_TYPES.COLUMN,
    },
    {
        text: 'Bathrooms',
        value: 'bathrooms_descending',
        field: 'bathrooms',
        direction: 'desc',
        type: SORT_TYPES.COLUMN,
    },
    {
        text: 'Square Feet',
        value: 'square_feet_descending',
        field: 'size',
        direction: 'desc',
        type: SORT_TYPES.COLUMN,
    },
    {
        text: 'Newest',
        value: 'new_listings_descending',
        field: 'details.listingDate',
        direction: 'desc',
        type: SORT_TYPES.COLUMN,
    },
    {
        text: 'Most Photos',
        value: 'most_photos_descending',
        field: 'details.imageCount',
        direction: 'desc',
        type: SORT_TYPES.COLUMN,
    },
];

const SQUARE_FEET = {
    min: [
        {
            value: 0,
            label: 'No Min'
        },
        {
            value: 500,
            label: '500 sqft'
        },
        {
            value: 750,
            label: '750 sqft'
        },
        {
            value: 1000,
            label: '1000 sqft'
        },
        {
            value: 1250,
            label: '1250 sqft'
        },
        {
            value: 1500,
            label: '1500 sqft'
        },
        {
            value: 1750,
            label: '1750 sqft'
        },
        {
            value: 2000,
            label: '2000 sqft'
        },
        {
            value: 2250,
            label: '2250 sqft'
        },
        {
            value: 2500,
            label: '2500 sqft'
        },
        {
            value: 2750,
            label: '2750 sqft'
        },
        {
            value: 3000,
            label: '3000 sqft'
        },
        {
            value: 3500,
            label: '3500 sqft'
        },
        {
            value: 4000,
            label: '4000 sqft'
        },
        {
            value: 5000,
            label: '5000 sqft'
        },
        {
            value: 7500,
            label: '7500 sqft'
        },
    ],
    max: [
        {
            value: null,
            label: 'No Max'
        },
        {
            value: 500,
            label: '500 sqft'
        },
        {
            value: 750,
            label: '750 sqft'
        },
        {
            value: 1000,
            label: '1000 sqft'
        },
        {
            value: 1250,
            label: '1250 sqft'
        },
        {
            value: 1500,
            label: '1500 sqft'
        },
        {
            value: 1750,
            label: '1750 sqft'
        },
        {
            value: 2000,
            label: '2000 sqft'
        },
        {
            value: 2250,
            label: '2250 sqft'
        },
        {
            value: 2500,
            label: '2500 sqft'
        },
        {
            value: 2750,
            label: '2750 sqft'
        },
        {
            value: 3000,
            label: '3000 sqft'
        },
        {
            value: 3500,
            label: '3500 sqft'
        },
        {
            value: 4000,
            label: '4000 sqft'
        },
        {
            value: 5000,
            label: '5000 sqft'
        },
        {
            value: 7500,
            label: '7500 sqft'
        },
    ],
};

const LOT_SIZE = {
    min: [
        {
            value: 0,
            label: 'No Min'
        },
        {
            value: 2000,
            label: '2000 sqft'
        },
        {
            value: 3000,
            label: '3000 sqft'
        },
        {
            value: 4000,
            label: '4000 sqft'
        },
        {
            value: 5000,
            label: '5000 sqft'
        },
        {
            value: 7500,
            label: '7500 sqft'
        },
        {
            value: 10890,
            label: '.25 acres'
        },
        {
            value: 21780,
            label: '.5 acres'
        },
        {
            value: 43560,
            label: '1 acre'
        },
        {
            value: 87120,
            label: '2 acres'
        },
        {
            value: 217800,
            label: '5 acres'
        },
        {
            value: 435600,
            label: '10 acres'
        },
        {
            value: 174240,
            label: '40 acres'
        },
        {
            value: 4356000,
            label: '100 acres'
        },
    ],
    max: [
        {
            value: null,
            label: 'No Max'
        },
        {
            value: 2000,
            label: '2000 sqft'
        },
        {
            value: 3000,
            label: '3000 sqft'
        },
        {
            value: 4000,
            label: '4000 sqft'
        },
        {
            value: 5000,
            label: '5000 sqft'
        },
        {
            value: 7500,
            label: '7500 sqft'
        },
        {
            value: 10890,
            label: '.25 acres'
        },
        {
            value: 21780,
            label: '.5 acres'
        },
        {
            value: 43560,
            label: '1 acre'
        },
        {
            value: 87120,
            label: '2 acres'
        },
        {
            value: 217800,
            label: '5 acres'
        },
        {
            value: 435600,
            label: '10 acres'
        },
        {
            value: 174240,
            label: '40 acres'
        },
        {
            value: 4356000,
            label: '100 acres'
        },
    ],
};

const YEAR_BUILT = {
    min: [
        {
            value: 0,
            label: 'No Min'
        },
        {
            value: 2020,
            label: '2020'
        },
        {
            value: 2019,
            label: '2019'
        },
        {
            value: 2018,
            label: '2018'
        },
        {
            value: 2017,
            label: '2017'
        },
        {
            value: 2016,
            label: '2016'
        },
        {
            value: 2015,
            label: '2015'
        },
        {
            value: 2010,
            label: '2010'
        },
        {
            value: 2005,
            label: '2005'
        },
        {
            value: 2000,
            label: '2000'
        },
        {
            value: 1990,
            label: '1990'
        },
        {
            value: 1980,
            label: '1980'
        },
        {
            value: 1970,
            label: '1970'
        },
        {
            value: 1960,
            label: '1960'
        },
        {
            value: 1950,
            label: '1950'
        },
        {
            value: 1940,
            label: '1940'
        },
        {
            value: 1930,
            label: '1930'
        },
        {
            value: 1920,
            label: '1920'
        },
        {
            value: 1910,
            label: '1910'
        },
        {
            value: 1900,
            label: '1900'
        },
    ],
    max: [
        {
            value: null,
            label: 'No Max'
        },
        {
            value: 2020,
            label: '2020'
        },
        {
            value: 2019,
            label: '2019'
        },
        {
            value: 2018,
            label: '2018'
        },
        {
            value: 2017,
            label: '2017'
        },
        {
            value: 2016,
            label: '2016'
        },
        {
            value: 2015,
            label: '2015'
        },
        {
            value: 2010,
            label: '2010'
        },
        {
            value: 2005,
            label: '2005'
        },
        {
            value: 2000,
            label: '2000'
        },
        {
            value: 1990,
            label: '1990'
        },
        {
            value: 1980,
            label: '1980'
        },
        {
            value: 1970,
            label: '1970'
        },
        {
            value: 1960,
            label: '1960'
        },
        {
            value: 1950,
            label: '1950'
        },
        {
            value: 1940,
            label: '1940'
        },
        {
            value: 1930,
            label: '1930'
        },
        {
            value: 1920,
            label: '1920'
        },
        {
            value: 1910,
            label: '1910'
        },
        {
            value: 1900,
            label: '1900'
        },
    ],
};

const KEYWORDS = [
    {
        text: 'Dining Room',
        value: 'dining room',
    },
    {
        text: 'Dock',
        value: 'dock',
    },
    {
        text: 'doors',
        value: 'doors',
    },
    {
        text: 'Double Ovens',
        value: 'double ovens',
    },
    {
        text: 'Double Sinks',
        value: 'double sinks',
    },
    {
        text: 'Double Vanity',
        value: 'double vanity',
    },
    {
        text: 'Eat-in-kitchen',
        value: 'eat-in-kitchen',
    },
    {
        text: 'Entertaining',
        value: 'entertaining',
    },
    {
        text: 'Entry',
        value: 'entry',
    },
    {
        text: 'Exterior',
        value: 'exterior',
    },
    {
        text: 'Extra Storage',
        value: 'extra storage',
    },
    {
        text: 'Fenced',
        value: 'fenced',
    },
    {
        text: 'Fenced Backyard',
        value: 'fenced backyard',
    },
    {
        text: 'First Time Home Buyer',
        value: 'first time home buyer',
    },
    {
        text: 'Formal Dining',
        value: 'formal dining',
    },
    {
        text: 'Full Bath',
        value: 'full bath',
    },
    {
        text: 'Garden',
        value: 'garden',
    },
    {
        text: 'Gas Fireplace',
        value: 'gas fireplace',
    },
    {
        text: 'Gated Community',
        value: 'gated community',
    },
    {
        text: 'Glass Doors',
        value: 'glass doors',
    },
    {
        text: 'Granite Counters',
        value: 'granite counters',
    },
    {
        text: 'Great Views',
        value: 'great views',
    },
    {
        text: 'Immaculate Condition',
        value: 'immaculate condition',
    },
    {
        text: 'In-ground Pool',
        value: 'in-ground pool',
    },
    {
        text: 'Investment',
        value: 'investment',
    },
    {
        text: 'Investor',
        value: 'investor',
    },
    {
        text: 'Island',
        value: 'island',
    },
    {
        text: 'Kitchen',
        value: 'kitchen',
    },
    {
        text: 'Kitchen and Baths',
        value: 'kitchen and baths',
    },
    {
        text: 'Kitchen Appliances',
        value: 'kitchen appliances',
    },
    {
        text: 'Kitchen with Island',
        value: 'kitchen with island',
    },
    {
        text: 'Kitchen with Bathrooms',
        value: 'kitchen with bathrooms',
    },
    {
        text: 'Main Living Area',
        value: 'main living area',
    },
    {
        text: 'Master Bedroom',
        value: 'master bedroom',
    },
    {
        text: 'Master Suite',
        value: 'master suite',
    },
    {
        text: 'Move-in Condition',
        value: 'move-in condition',
    },
    {
        text: 'Move-in Ready',
        value: 'move-in ready',
    },
    {
        text: 'Paint',
        value: 'paint',
    },
    {
        text: 'Patio',
        value: 'pation',
    },
    {
        text: 'Pool',
        value: 'pool',
    },
    {
        text: 'Porch',
        value: 'porch',
    },
    {
        text: 'Possibilities',
        value: 'possibilities',
    },
    {
        text: 'Recessed Lighting',
        value: 'recessed lighting',
    },
    {
        text: 'Refrigerator',
        value: 'refrigerator',
    },
    {
        text: 'Remodel',
        value: 'remodel',
    },
    {
        text: 'Renovation',
        value: 'renovation',
    },
    {
        text: 'Restaurants',
        value: 'restaurants',
    },
    {
        text: 'Second Bedroom',
        value: 'second bedroom',
    },
    {
        text: 'Second Floor',
        value: 'second floor',
    },
    {
        text: 'Separate Dining Room',
        value: 'separate dining room',
    },
    {
        text: 'Shopping',
        value: 'shopping',
    },
    {
        text: 'Skylights',
        value: 'skylights',
    },
    {
        text: 'Tennis Courts',
        value: 'tennis courts',
    },
    {
        text: 'Tile Floors',
        value: 'tile floors',
    },
    {
        text: 'Townhome',
        value: 'townhome',
    },
    {
        text: 'Tray Ceilings',
        value: 'tray ceilings',
    },
    {
        text: 'Trees',
        value: 'trees',
    },
    {
        text: 'Vacation',
        value: 'vacation',
    },
    {
        text: 'Vanity',
        value: 'vanity',
    },
    {
        text: 'Vaulted Ceiling',
        value: 'vaulted ceiling',
    },
    {
        text: 'Views',
        value: 'views',
    },
    {
        text: 'Virtual Tour',
        value: 'virtual tour',
    },
    {
        text: 'Walk in Closet',
        value: 'walk in closet',
    },
    {
        text: 'Washer Dryer',
        value: 'washer dryer',
    },
    {
        text: 'Wonderful Home',
        value: 'wonderful home',
    },
    {
        text: 'Wood-burning Fireplace',
        value: 'wood-burning fireplace',
    },
    {
        text: 'Zabars',
        value: 'zabars',
    },
    {
        text: 'Zen Garden',
        value: 'zen garden',
    },
    {
        text: 'Zero Lot Line',
        value: 'zero lot line',
    },
    {
        text: 'Zoned Bedrooms',
        value: 'zoned bedrooms',
    },
    {
        text: 'Zoning',
        value: 'zoning',
    },
];

const IS_SOLD = [
    {
        text: 'Recently Sold',
        value: true,
    },
    {
        text: 'Listings For Sale',
        value: false,
    },
];

export {
    PRICES,
    BEDS,
    BATHS,
    HOME_TYPES,
    SALE_TYPES,
    SORT_FIELDS,
    SORT_TYPES,
    SQUARE_FEET,
    LOT_SIZE,
    YEAR_BUILT,
    KEYWORDS,
    IS_SOLD,
};
